import { ServiceSelectionAction } from 'actions/SelectedServicesActions';

import {
  CLEAR_SERVICES,
  MAX_APPOINTMENTS_WARNING_ACKNOWLEDGED,
  SELECT_SERVICE,
  UNSELECT_SERVICE,
} from '../actions/ActionTypes';

export type ServiceSelection = {
  guid: string;
  providerGuid?: string;
  optionId?: string;
  bookingOrder?: number;
};

const initialState: ServiceSelection[] = [];

export default function selectedServices(
  state: ServiceSelection[] = initialState,
  action: ServiceSelectionAction,
): ServiceSelection[] {
  switch (action.type) {
    case CLEAR_SERVICES:
      return initialState;
    case SELECT_SERVICE:
      const filteredState = state.filter((s) => s.guid !== action.payload.guid);

      return [...filteredState, action.payload];
    case UNSELECT_SERVICE:
      return state.filter((s) => s.guid !== action.payload.guid);
    case MAX_APPOINTMENTS_WARNING_ACKNOWLEDGED:
      // Remove the triggering service when max appointments warning is acknowledged
      // The triggeringServiceGuid could be either a base service GUID or an optionId
      return state.filter((s) => {
        const triggeringGuid = (action as any).triggeringServiceGuid;

        return s.guid !== triggeringGuid && s.optionId !== triggeringGuid;
      });
    default:
      return state;
  }
}
